import React, { useEffect, useRef } from 'react';
import { gsap } from '../../../gsap';
import './Indicator.scss';

function Indicator({ currentEra, eras, origin, eraData }) {
  const indicatorRef = useRef();
  const activeRef = useRef();
  useEffect(() => {
    if (origin === 'intro') {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: indicatorRef.current,
          start: 'top 50%'
        }
      });
      tl.to(indicatorRef.current, { x: 0, duration: 0.7 })
        .to(activeRef.current, { scale: 1.1, duration: 0.3 })
        .to(activeRef.current, { scale: 1, duration: 0.5 });
    }
  }, [origin]);
  return (
    <div className={`indicator indicator-${origin}`} ref={origin === 'intro' ? indicatorRef : null}>
      {eras.map((content, i) => {
        return (
          <div key={i}>
            {origin === 'carousel' ? (
              <svg
                className={
                  currentEra === i
                    ? 'indicator__circle indicator__circle--active'
                    : 'indicator__circle'
                }
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
              >
                <title>circle</title>
                <circle cx="8" cy="8" r="6" />
              </svg>
            ) : (
              <a href={`#${eraData.id}`}>
                <div
                  ref={eraData.index === i ? activeRef : null}
                  className={
                    eraData.index === i ? 'indicator__bar indicator__bar--active' : 'indicator__bar'
                  }
                />
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Indicator;
